<template>
  <div class="bbp-total-card" @click="setActive">
    <div class="bbp-total-card-mark" :class="{'bbp-total-card-mark_active': active}">
      <i class="bbp-icon-check-mark bbp-total-card-mark__icon"/>
    </div>
    <div class="bbp-total-card__title" :class="{'bbp-total-card__title_active': active}">
      {{title}}
    </div>
    <div class="bbp-total-card__number">
      <ICountUp
        :delay="countUp.delay"
        :startVal="0"
        :endVal="endVal || 0"
        :options="countUp.options"
      />
    </div>
  </div>
</template>

<script>
import ICountUp from 'vue-countup-v2'

export default {
  name: 'BBPTotalCard',
  props: ['title', 'endVal', 'active', 'item'],
  components: {
    ICountUp
  },
  data () {
    return {
      countUp: {
        delay: 0,
        options: {
          duration: 1,
          useEasing: false,
          useGrouping: true,
          separator: ',',
          decimal: '.',
          decimalPlaces: 2
        }
      }
    }
  },
  methods: {
    setActive () {
      this.$emit('setActive', this.item)
    }
  }
}
</script>

<style lang="scss" scoped>
  @import "../../../sass/variables";
  @import "../../../sass/mixins";

  .bbp-total-card {
    @include global-font;
    display: inline-grid;
    align-items: center;
    grid-template-columns: 36px auto auto;
    background: $color-white;
    border: 1px solid transparent;
    box-sizing: border-box;
    border-radius: 5px;
    margin-right: 8px;
    min-width: 189px;
    cursor: pointer;
    user-select: none;
    transition: 0.3s;

    &:hover &__title {
      color: $color-accent-hover;
    }

    &-mark {
      width: 14px;
      height: 14px;
      display: flex;
      align-items: center;
      justify-content: center;
      border: 1px solid $color-accent;
      box-sizing: border-box;
      border-radius: 50%;
      font-size: 0;
      transition: 0.3s;
      margin: 14px 8px 14px 14px;

      &_active {
        font-size: 8px;
        background-color: $color-accent;
      }

      &__icon {
        color: $color-white
      }
    }

    &__title {
      position: relative;
      font-weight: 600;
      font-size: 12px;
      line-height: 1;
      color: $color-black;
      padding: 14px 14px 14px 0;
      transition: 0.3s;

      &:after {
        content: '';
        position: absolute;
        top: -15px;
        right: 0;
        width: 1px;
        height: 100%;
        background-color: $color-alabaster;
      }

      &_active {
        color: $color-accent;
      }
    }

    &__number {
      text-align: center;
      font-weight: normal;
      font-size: 12px;
      line-height: 14px;
      padding: 14px;
    }
  }

</style>



// WEBPACK FOOTER //
// src/components/Main/BBPTotalCard/BBPTotalCard.vue